/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  Email,
  GetCalendarIntegrationStatusBatchRequest,
  IntegrationStatusBatchResultV3,
  IntegrationStatusBatchResultV4,
  IntegrationStatusesResponseV3,
  MapString,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V3<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "external-calendar";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Returns primary and secondary calendar connections for given user id with integration status
   *
   * @name CalendarIntegrationStatusV3
   * @request GET:/v3/tenant/{tenantId}/calendar-integration-status
   * @secure
   */
  calendarIntegrationStatusV3 = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      userId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      IntegrationStatusesResponseV3,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/calendar-integration-status`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for calendarIntegrationStatusV3 */
  calendarIntegrationStatusV3PathGetter = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      userId: string;
    },
  ) => this.getServicePath(`/v3/tenant/${tenantId}/calendar-integration-status`, query);

  /**
   * @description Returns primary and secondary connections for a given set of user ids
   *
   * @name CalendarIntegrationStatus
   * @request POST:/v3/tenant/{tenantId}/calendar-integration-status
   * @secure
   */
  calendarIntegrationStatus = (
    tenantId: string,
    data: GetCalendarIntegrationStatusBatchRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      IntegrationStatusBatchResultV4,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/calendar-integration-status`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for calendarIntegrationStatus */
  calendarIntegrationStatusPathGetter = (tenantId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/calendar-integration-status`);

  /**
   * @description Get Google connections for a list of users
   *
   * @name GoogleIntegrationStatus
   * @request POST:/v3/tenant/{tenantId}/google-integration-status
   * @secure
   */
  googleIntegrationStatus = (tenantId: string, data?: string[], params: RequestParams = {}) =>
    this.request<
      IntegrationStatusBatchResultV3,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/google-integration-status`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for googleIntegrationStatus */
  googleIntegrationStatusPathGetter = (tenantId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/google-integration-status`);

  /**
   * @description Get Microsoft connections for a list of users
   *
   * @name MicrosoftIntegrationStatus
   * @request POST:/v3/tenant/{tenantId}/microsoft-integration-status
   * @secure
   */
  microsoftIntegrationStatus = (tenantId: string, data?: string[], params: RequestParams = {}) =>
    this.request<
      IntegrationStatusBatchResultV3,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/microsoft-integration-status`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for microsoftIntegrationStatus */
  microsoftIntegrationStatusPathGetter = (tenantId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/microsoft-integration-status`);
}
